import React from 'react';

import { Grid } from '@material-ui/core';

import clsx from 'clsx';
import { CutoutOrganogramList } from './CutoutOrganogramList';
import { CutoutOrganogramItem } from './CutoutOrganogramItem';
import { IOrganogramAccordionItemProps, OrganogramAccordion, OrganogramAccordionSummary, organogramAccordionStyles} from '../../../../../shared/components/OrganogramAccordion';

export function CutoutOrganogramAccordionItem({organogram, textLevel, isParent, level, listOrg}: IOrganogramAccordionItemProps) {
    const classes = organogramAccordionStyles();

    const [expanded, setExpanded] = React.useState<boolean>(false);

    return (
        <Grid 
            key={organogram.id}
            item 
            xs={12}>
            <OrganogramAccordion 
                key={organogram.id}
                elevation={0}>
                <OrganogramAccordionSummary 
                    key={organogram.id}
                    onClick={() => isParent && setExpanded(!expanded)}
                    className={clsx({[classes.notClickableAccordion]: !isParent })}>
                    <CutoutOrganogramItem 
                        key={organogram.id} 
                        item={organogram} 
                        level={level} 
                        isParent={isParent} 
                        expanded={expanded}/>
                </OrganogramAccordionSummary>
                {expanded && <CutoutOrganogramList 
                    key={organogram.id}
                    listOrg={listOrg} 
                    parent={organogram.id} 
                    level={level+1} 
                    textLevel={`${textLevel} ${organogram.description} >`}/>}
            </OrganogramAccordion>
        </Grid>
    );
}